import { FC, useState, useEffect } from 'react';
import { Select, SingleDatePicker } from '../../Universal/NovusDSImports';
import {
  selectStyles,
  singleDatePickerStyles
} from '../../Universal/NovusDSImports/variants';
import { Controller, useFormContext } from 'react-hook-form';
import {
  getYearDropdownOptions,
  monthsListDropdownOptions
} from '../../Constants/constants';

interface ResourcesDateSelectorProps {
  name: string;
  labelPrefix: string;
}

const ResourcesDateSelector: FC<ResourcesDateSelectorProps> = (props) => {
  const { name, labelPrefix } = props;
  const {
    control,
    watch,
    getValues,
    trigger,
    formState: { errors, isSubmitted }
  } = useFormContext();

  const [yearOptions, setYearOptions] = useState<any>(null);

  const reportType = watch('reportType');
  const intentOption = watch('intentOption');

  useEffect(() => {
    if (reportType && reportType !== 'full_details') {
      const options = getYearDropdownOptions();

      setYearOptions(options);
    }
  }, [reportType]);

  requestAnimationFrame(() => {
    document
      .querySelector('[id="Start-Date"]')
      ?.removeAttribute('aria-labelledby');
    document
      .querySelector('[id="End-Date"]')
      ?.removeAttribute('aria-labelledby');
  });

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return reportType === 'full_details' ||
            intentOption === 'view_map' ? (
            <SingleDatePicker
              {...field}
              label={`${labelPrefix} Date`}
              id={`${labelPrefix}-Date`}
              selected={field.value}
              onChange={(e) => {
                const newDate = new Date(e);
                newDate.setHours(name === 'startDate' ? 0 : 22, 0, 0, 0);
                field.onChange(newDate);
                if (isSubmitted && name === 'startDate') {
                  trigger('endDate');
                }
              }}
              {...singleDatePickerStyles}
            />
          ) : (
            <div>
              {reportType === 'events_by_month' && (
                <Select
                  {...field}
                  asterisk
                  options={monthsListDropdownOptions}
                  displayName={`${labelPrefix} Month`}
                  aria-label={`${labelPrefix} Month`}
                  placeholder="Please Select Month"
                  value={monthsListDropdownOptions[field.value?.getMonth()]}
                  onChange={(e) => {
                    const newDate = getValues(name) || new Date();
                    newDate.setMonth(parseInt(e.value));
                    newDate.setHours(name === 'startDate' ? 0 : 22, 0, 0, 0);
                    field.onChange(newDate);
                    if (isSubmitted && name === 'startDate') {
                      trigger('endDate');
                    }
                  }}
                  {...selectStyles}
                />
              )}
              <Select
                {...field}
                asterisk
                options={yearOptions}
                displayName={`${labelPrefix} Year`}
                aria-label={`${labelPrefix} Year`}
                placeholder="Please Select Year"
                value={getYearDropdownOptions().find(
                  (year) => year.value === field.value?.getFullYear()
                )}
                onChange={(e) => {
                  const newDate = getValues(name) || new Date();
                  newDate.setYear(e.value);
                  newDate.setHours(name === 'startDate' ? 0 : 22, 0, 0, 0);
                  field.onChange(newDate);
                  if (isSubmitted && name === 'startDate') {
                    trigger('endDate');
                  }
                }}
                {...selectStyles}
              />
            </div>
          );
        }}
      />
      <div className="error-text">{errors?.[name]?.message?.toString()}</div>
    </div>
  );
};

export default ResourcesDateSelector;
